/* eslint-disable import/prefer-default-export */
export function formatCardTags(card) {
  const {
    marketingWords = [],
    pendingInfos = [],
  } = card;

  return marketingWords.reduce((tags, item) => {
    const v = { ...item };
    if (item.wordsType === 8) {
      let pendingCitys = '';
      if (pendingInfos.length) {
        pendingCitys = pendingInfos[0].pendingName;
        if (pendingInfos.length > 1) {
          pendingCitys += '等';
        }
        const cityString = `限${pendingCitys}`;
        v.wordsValue = cityString;
      }
      if (item.wordsValue.length > 7) {
        v.wordsValue = `${item.wordsValue.substring(0, 6)}...`;
      }
    }
    // wordsType === 5是guideRecommend， wordsType === 6是topRecommend
    if (item.wordsType !== 1 && item.wordsType !== 5 && item.wordsType !== 6) {
      tags.push(v);
    }
    return tags;
  }, []);
}
